import { Seo } from "@/components/Seo";
import { LinkedInMessageLink } from "@/features/contact/LinkedInMessageLink";
import { site } from "@/config/site";

export function ContactPage() {
  return (
    <>
      <Seo
        title="Contact"
        description="Message Jay van Zyl on LinkedIn about workshops, ecosystem.Ai, EcosystemCode, or speaking."
        path="/contact"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Contact</p>
        <h1>If you are putting prediction into production — or deciding whether you should — write to me on LinkedIn</h1>
        <p className="lede">
          I read LinkedIn messages myself. Open the profile, send a note, and say
          whether it is a workshop, ecosystem.Ai, EcosystemCode, or speaking.
        </p>
        <p>
          <LinkedInMessageLink className="button" />
        </p>
        <p className="meta" style={{ marginTop: "1.5rem" }}>
          Also: <a href={site.profiles.ecosystem}>ecosystem.Ai</a> ·{" "}
          <a href={site.profiles.github}>GitHub</a>
        </p>
      </section>
    </>
  );
}
